const infractionBalanceBlockStatus = {
  processing: 'processing',
  incomplete: 'incomplete',
  complete: 'complete'
};

module.exports = infractionBalanceBlockStatus;
